module.exports = __webpack_public_path__ + "img/Daniel Vaczi.5e8d1419.jpg";